const faqs = [
  {
    q: '91影视看片app真的完全免费吗？',
    a: '是的，91影视看片app承诺永久免费。无需注册、无需付费、无需会员，打开即可观看所有高清影视内容。我们通过广告合作维持平台运营，用户无需承担任何费用。',
  },
  {
    q: '看片会不会卡顿或缓冲很久？',
    a: '平台采用智能多节点调度技术，根据你的网络环境自动匹配最优播放线路。在正常网络条件下，高清视频可实现秒开播放，告别缓冲等待。4G与WiFi环境下均有流畅体验。',
  },
  {
    q: '支持哪些设备观看？片源更新频率如何？',
    a: '支持手机、平板、电脑全平台观看，观影记录多端自动同步。片源每日更新，热播剧集上线后2小时内即可在平台观看，保障你不错过任何精彩内容。',
  },
  {
    q: '为什么有的影片搜不到？如何反馈问题？',
    a: '平台片源持续扩充中，如遇到想看的影片暂未收录，可通过「联系我们」页面提交片源推荐。播放问题或功能建议也可通过反馈渠道联系我们，技术团队会尽快处理。',
  },
];

export default function FAQSection() {
  return (
    <section id="faq" className="py-14 md:py-20 px-4 md:px-6 bg-background-100">
      <div className="max-w-3xl mx-auto">
        <h2 className="text-2xl md:text-3xl font-bold text-foreground-950 font-heading text-center mb-4">常见问题</h2>
        <p className="text-sm text-foreground-500 text-center mb-10">关于91影视看片app的常见疑问解答</p>

        <div className="space-y-4">
          {faqs.map((faq, i) => (
            <div key={i} className="rounded-2xl bg-background-50 border border-background-200/70 p-6">
              <h3 className="text-base font-bold text-foreground-900 mb-3 flex items-start gap-3">
                <span className="flex-shrink-0 w-6 h-6 flex items-center justify-center rounded-lg bg-primary-100 text-primary-600 text-sm font-bold">Q</span>
                {faq.q}
              </h3>
              <p className="text-sm text-foreground-600 leading-relaxed pl-9">{faq.a}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}